import classnames from "classnames";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { EU_COUNTRIES } from "../../constants";
import styles from "./legal-agreement.css";

function createMarkup(value) {
    return { __html: value };
}

function LegalAgreement({
    captureType,
    className,
    cookiePolicyLink,
    country,
    handleLegalChange,
    privacyPolicyLink,
    shortEUVersion,
    submitText,
    termsAndConditionsLink,
}) {
    const [privacyPolicy, setPrivacyPolicy] = useState(false);
    const [marketingEmails, setMarketingEmails] = useState(false);
    const [marketingEmailsRestOfWorld, setMarketingEmailsRestOfWorld] = useState(true);
    const privacyPolicyLinkProps = `href=${privacyPolicyLink} target="_blank"`;
    const termsAndConditionsLinkProps = `href=${termsAndConditionsLink} target="_blank"`;
    const cookiePolicyLinkProps = `href=${cookiePolicyLink} target="_blank"`;
    if (EU_COUNTRIES.has(country)) {
        if (shortEUVersion) {
            handleLegalChange(true, marketingEmails);
            return (
                <div className={styles.legalAgreement}>
                    <div className={styles.checkboxFieldset}>
                        <input
                            className={styles.checkbox}
                            type="checkbox"
                            name="marketing_emails"
                            checked={marketingEmails}
                            id="marketing-emails"
                            required
                            onChange={(e) => {
                                const action = e.target.checked ? "tick_box" : "untick_box";
                                analytics.event(captureType, action, "tickbox_marketing");
                                setMarketingEmails(e.target.checked);
                                handleLegalChange(true, e.target.checked);
                            }}
                        />
                        <label
                            htmlFor="marketing-emails"
                            dangerouslySetInnerHTML={createMarkup(
                                gettext(
                                    "account.register.legal_agreement.email_opt_in_checkbox_label"
                                )
                            )}
                        />
                    </div>
                </div>
            );
        } else {
            return (
                <div className={classnames(className, styles.legalAgreement)}>
                    <div className={styles.checkboxFieldset}>
                        <input
                            className={styles.checkbox}
                            type="checkbox"
                            name="marketing_emails"
                            checked={marketingEmails}
                            id="marketing-emails"
                            onChange={(e) => {
                                const action = e.target.checked ? "tick_box" : "untick_box";
                                analytics.event(captureType, action, "tickbox_marketing");
                                setMarketingEmails(e.target.checked);
                                handleLegalChange(privacyPolicy, e.target.checked);
                            }}
                        />
                        <label
                            htmlFor="marketing-emails"
                            dangerouslySetInnerHTML={createMarkup(
                                gettext(
                                    "account.register.legal_agreement.email_opt_in_checkbox_label"
                                )
                            )}
                        />
                    </div>
                    <div className={styles.checkboxFieldset}>
                        <input
                            className={styles.checkbox}
                            type="checkbox"
                            name="privacy_policy"
                            id="privacy-policy"
                            checked={privacyPolicy}
                            onChange={(e) => {
                                const action = e.target.checked ? "tick_box" : "untick_box";
                                analytics.event(captureType, action, "tickbox_privacy_policy");
                                setPrivacyPolicy(e.target.checked);
                                handleLegalChange(e.target.checked, marketingEmails);
                            }}
                        />
                        <label
                            htmlFor="privacy-policy"
                            dangerouslySetInnerHTML={createMarkup(
                                gettext(
                                    "account.register.legal_agreement.privacy_policy_checkbox_label",
                                    {
                                        privacy_policy_link_props: privacyPolicyLinkProps,
                                    }
                                )
                            )}
                        />
                    </div>
                </div>
            );
        }
    } else if (country === "US") {
        handleLegalChange(true, true);
        return (
            <div
                className={classnames(className, styles.legalAgreementSmall)}
                dangerouslySetInnerHTML={createMarkup(
                    gettext("account.register.legal_agreement.us_text", {
                        submit_btn_text: submitText,
                        terms_and_conditions_link_props: termsAndConditionsLinkProps,
                        privacy_policy_link_props: privacyPolicyLinkProps,
                        cookie_policy_link_props: cookiePolicyLinkProps,
                    })
                )}
            />
        );
    } else {
        handleLegalChange(true, marketingEmailsRestOfWorld);
        return (
            <div className={classnames(className, styles.legalAgreementSmall)}>
                <div
                    className={styles.rowDisclaimer}
                    dangerouslySetInnerHTML={createMarkup(
                        gettext("account.register.legal_agreement.rest_of_world_text", {
                            submit_btn_text: submitText,
                            terms_and_conditions_link_props: termsAndConditionsLinkProps,
                            privacy_policy_link_props: privacyPolicyLinkProps,
                            cookie_policy_link_props: cookiePolicyLinkProps,
                        })
                    )}
                />
                <div className={styles.checkboxFieldset}>
                    <input
                        className={styles.checkbox}
                        type="checkbox"
                        name="marketing_emails"
                        checked={marketingEmailsRestOfWorld}
                        id="marketing-emails"
                        required
                        onChange={(e) => {
                            const action = e.target.checked ? "tick_box" : "untick_box";
                            analytics.event(captureType, action, "tickbox_marketing");
                            setMarketingEmailsRestOfWorld(e.target.checked);
                            handleLegalChange(true, e.target.checked);
                        }}
                    />
                    <label
                        htmlFor="marketing-emails"
                        dangerouslySetInnerHTML={createMarkup(
                            gettext("account.register.legal_agreement.rest_of_world_checkbox_label")
                        )}
                    />
                </div>
            </div>
        );
    }
}

export default LegalAgreement;

LegalAgreement.propTypes = {
    captureType: PropTypes.string,
    className: PropTypes.string,
    cookiePolicyLink: PropTypes.string,
    country: PropTypes.string,
    handleLegalChange: PropTypes.func.isRequired,
    privacyPolicyLink: PropTypes.string.isRequired,
    shortEUVersion: PropTypes.bool,
    submitText: PropTypes.string,
    termsAndConditionsLink: PropTypes.string,
};
